import React from 'react';
import ProjectsItems from './ProjectsItems';

const ProjectsSection = ({ data, dateFormat }) => {
  const Projects = () =>
    data.projects &&
    data.projects.enable &&
    data.projects.items.filter((x) => x.enable).length > 0 &&
    data.projects.items
      .filter((x) => x.enable)
      .map((value) => (
        <ProjectsItems key={`project${value.id}`} x={value} dateFormat={dateFormat} />
      ));

  return (
    <>
      <div className="col-span-12 px-10 py-10 pb-4">
        <div className="font-bold" style={{ fontSize: 32 }}>
          Projects
        </div>
      </div>
      <Projects />
    </>
  );
};

export default ProjectsSection;
